// this file is generated by update_shopify_store_data.py at 2026-03-18 20:34:40.201976
var courses = [
    {
        "course_id": "492BD37C-27BB-F011-99A0-005056A78EAA",
        "course_version": 1,
        "name": "Nutrition for Successful Aging: Optimizing Healthspan",
        "course_type": 1,
        "author_information": "Carol Zigler, DNP, FNP-C, APHN-BC",
        "description": "As we live longer lives, nutrition plays a critical role in supporting health, independence, and quality of life\u2014but aging doesn\u2019t happen in a vacuum. Climate change, disrupted food systems, and environmental stressors increasingly affect how and what we eat, especially for older adults. This course examines the intersection of aging, nutrition, and Planetary Health, exploring how food access, equity, and sustainability shape the aging experience. Through a justice-focused lens, you\u2019ll learn how to support healthy aging in individuals and communities while building resilience for future generations.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ol>Explain how aging affects nutritional needs and identify key dietary patterns that support health and longevity in older adults. </ol>\r\n    <ol>Analyse the impact of climate change and food systems on nutrition and health outcomes among aging populations. </ol>\r\n        <ol>Apply Planetary Health principles to develop strategies that promote equitable, sustainable nutrition for older adults at individual and community levels.\r\n        </ol>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "C48CC568-F7D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Nutrition for Successful Aging: Optimizing Healthspan",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71021ACF-F5D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing: Nutrition for Successful Aging: Optimizing Healthspan",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E64A7C75-8EC5-E811-AEE3-005056B11CD6",
                "course_category_name": "Population Health Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D6EC53E-1F26-E711-9EDE-005056B14F90",
                "course_category_name": "Geriatric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "62F4CAD0-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nutrition",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 0.5 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 0.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];